/**
 * 契約API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 契約共通情報
 */
export interface Szoa304aRequestCtrCommonInfo { 
    /**
     * 契約終了日区分：英数字<br>　コード変換マスターテーブル.画面項目ID「C410190」のユーザコードを設定
     */
    ctrendDateDiv: string;
    /**
     * 契約終了年月：日付（yyyyMM）
     */
    ctrendYm?: string;
    /**
     * 契約終了日付：日付(yyyyMMdd)
     */
    ctrendDate?: string;
    /**
     * 契約変更日区分：英数字<br>　コード変換マスターテーブル.画面項目ID「C410180」のユーザコードを設定
     */
    ctrchgDateDiv: string;
    /**
     * 契約変更年月：日付（yyyyMM）<br>指定した変更年月の定例検針日翌日が変更日付となる。
     */
    ctrchgYm?: string;
    /**
     * 契約変更日付：日付(yyyyMMdd)
     */
    ctrChgDate?: string;
    /**
     * 請求月度区分：英数字<br>　コード変換マスターテーブル.画面項目ID「C021080」のユーザコードを設定
     */
    claimMntdiv: string;
    /**
     * 中継店申込番号：英数字
     */
    rlysrnNo?: string;
    /**
     * 中継店担当者名：全角
     */
    rlystrFname?: string;
    /**
     * 取次店発行お客さま番号：英数字
     */
    agnissVisitNo?: string;
    /**
     * プロダクトコード：英数字
     */
    prdCode: string;
    /**
     * サービス契約締結日付：日付(yyyyMMdd)
     */
    prdCtrDate?: string;
    /**
     * 契約管轄組織番号：英数字
     */
    ctrSosikiId?: string;
    /**
     * 契約締結組織番号：英数字
     */
    tantoSosikiId?: string;
    /**
     * 契約締結社員番号：英数字
     */
    tantoStaffNo?: string;
}

